import { CultureInfo } from '../culture-info.model';
import { CultureInfoOs } from './os';

/**
 * @ignore
 */
export const CultureInfoOsGE: CultureInfo = {
  name: 'os-GE',
  displayName: 'ирон (Гуырдзыстон)',
  iso3LanguageCode: 'oss',
  iso2LanguageCode: 'os',
  ietfLanguageTag: 'os-GE',
  parent: CultureInfoOs
};
